import React, { SyntheticEvent, useEffect, useState } from 'react';
import {
  CircularProgress,
  Autocomplete,
  debounce,
  TextField,
} from '@mui/material';
import { useSearchPostcodes } from '../hooks/data';
import { IPostcode } from '../Interfaces/IPostcode';
import { useGetPostcode } from '../hooks/reactQuerys/PostcodeQueries';

interface IProps {
  idPostcode: number | null;
  setIdPostcode: Function;
  required?: boolean;
}

export const PostcodeSearchByID = ({
  idPostcode,
  setIdPostcode,
  required,
}: IProps) => {
  const { postcode, isLoadingPostcode } = useGetPostcode(idPostcode);
  const [postcodeObject, setPostcodeObject] = useState<IPostcode | null>(null);

  const [open, setOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState(searchTerm);

  useEffect(() => {
    if (postcode !== undefined) {
      setPostcodeObject(postcode);
      executeSearch(`${postcode.Postcode}`);
    }
  }, [postcode]);

  const { postcodes, isLoadingPostcodes, abortSearchPostcodes } =
    useSearchPostcodes(debouncedSearchTerm);

  const options = postcodes ?? [];

  const executeSearch = (searchTerm: string) => {
    abortSearchPostcodes();
    setSearchTerm(searchTerm);
    const debouncedSearchTerm = debounce(setDebouncedSearchTerm, 500);
    debouncedSearchTerm(searchTerm);
  };
  const handleSearchTermChange = (_: SyntheticEvent, searchTerm: string) => {
    executeSearch(searchTerm);
  };

  return (
    <Autocomplete
      id='searchbar-postcode'
      fullWidth
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      value={postcodeObject}
      inputValue={searchTerm}
      isOptionEqualToValue={(option, value) =>
        option.idPostcode === value.idPostcode
      }
      filterOptions={x => x}
      getOptionLabel={option => `${option.Postcode} ${option.City}`}
      loadingText='Laden...'
      options={options}
      loading={isLoadingPostcodes || isLoadingPostcode}
      getOptionKey={option =>
        `${option.idPostcode}-${option.idCountry}-${option.City}`
      }
      onInputChange={handleSearchTermChange}
      onChange={(_, newObject) => {
        if (newObject) {
          setIdPostcode(newObject?.idPostcode);
          setPostcodeObject(newObject);
        }
      }}
      renderInput={params => (
        <TextField
          {...params}
          label='Postleitzahl'
          placeholder='Postleitzahl eingeben'
          size='small'
          required={required ?? true}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {isLoadingPostcodes && (
                  <CircularProgress color='inherit' size={20} />
                )}
                {searchTerm && params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
        />
      )}
    />
  );
};
